export const inchesToPx = (inches) => {
  return inches * 96
}

export const backgroundColor = (mode) => {
  return mode === "preview" ? "#000000" : "#f7fafc"
}

export const itemsFillColor = (mode) => {
  return mode === "preview" ? "#fff" : "#000"
}

export const drawBackground = (svgElement, mode, sizeMode = "preview", width = null, height = null) => {
  let rect

  if (sizeMode === "sized") {
    rect = svgElement.rect(width, height)
  } else {
    rect =  svgElement.rect("100%", "100%")
  }

  rect.attr({fill: backgroundColor(mode) })
}

export const downloadSVG = (svgElement, redrawFunction, name, drawingMode = "download") => {
  redrawFunction(drawingMode, "sized")

  const fileName = `${name}.svg`
  const url = "data:image/svg+xml;utf8," + encodeURIComponent(svgElement.svg())
  const link = document.createElement("a")

  link.download = fileName
  link.href = url
  link.click()

  redrawFunction("preview", "responsive")
}

export const resizeSVGBySizeMode = (svgElement, sizeMode, width, height) => {
  sizeMode === "responsive" ? svgElement.size("100%", "100%") : svgElement.size(width, height)
}

export const setViewboxByMode = (svgElement, mode, width, height) => {
  if (mode === "preview") {
    svgElement.viewbox(0, 0, width, height)
  } else {
    svgElement.node.removeAttribute("viewBox")
  }
}

export const downloadSvgAsPng = (svgElement, width, height, fileName) => {
  const canvas = document.createElement("canvas")
  const context = canvas.getContext("2d")

  canvas.setAttribute("width", width)
  canvas.setAttribute("height", height)

  const image = new Image()
  image.src = `data:image/svg+xml;base64,${btoa(svgElement.svg())}`
  image.onload = () => {
    context.drawImage(image, 0, 0)

    var canvasdata = canvas.toDataURL("image/png")
    var a = document.createElement("a")
    a.textContent = "save"
    a.download = `${fileName}.png`
    a.href = canvasdata;
    a.click()
  }

  canvas.remove()
}

export default {
  inchesToPx,
  backgroundColor,
  itemsFillColor,
  drawBackground,
  downloadSVG,
  resizeSVGBySizeMode,
  setViewboxByMode,
  downloadSvgAsPng
}
